import * as React from "react";
import "../filters.scss";
import {default as OptionSelector} from "../../../../hiberUiKit/src/molecules/OptionSelector/OptionSelector";
import RadioButton, {IRadioButton} from "../../../../hiberUiKit/src/atoms/Buttons/RadioButton";
import {none, option, Option} from "ts-option";
import {DateFilterType, DateFilterTypeName, unitsOfTime} from "./DateFilter";
import DateFilterModel from "../../../../model/workspace/DateFilterModel";
import {DateFilterValueItemApiDto} from "../../../../api/model/rest";
import NumberUtils from "../../../../utils/NumberUtils";
import moment = require("moment");
import DurationConstructor = moment.unitOfTime.DurationConstructor;

interface IProps {
	/**
	 * Input value
	 */
	value: Option<MoreThanAgoFilterModel>
	/**
	 * On change callback
	 * @param {Option<MoreThanAgoFilterModel>} value
	 */
	onChange: (value: Option<MoreThanAgoFilterModel>) => void
	/**
	 * Selected radio button Id
	 */
	selectedRadioButtonId: string
	/**
	 * On select button
	 * @param {string} id
	 */
	onSelectButton: (id: string) => void
}

interface IState {
	/**
	 * Selected unit of time for "More than ago"
	 */
	selectedUnitOfTime: DurationConstructor
	/**
	 * Represents value for end date for "More than ago"
	 * Start date precede this moment with 100 years
	 */
	inputEndValue: string
}


export default class MoreThanAgoFilter extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = {
			inputEndValue: props.value.map(v => v.timeValue.toString()).getOrElse(""),
			selectedUnitOfTime: props.value.map(v => v.unitOfTime).getOrElse("minutes"),
		};
		this.onChangeInput = this.onChangeInput.bind(this);
		this.onChangeSelector = this.onChangeSelector.bind(this);
		this.onChangeCallback = this.onChangeCallback.bind(this);
		this.resetFilter = this.resetFilter.bind(this);
	}

	componentWillReceiveProps(nextProps: IProps) {
		if (this.props.selectedRadioButtonId === this.radioButton.value &&
			nextProps.selectedRadioButtonId !== this.radioButton.value) {
			this.resetFilter();
		}
	}

	radioButton: IRadioButton = {
		label: DateFilterTypeName[DateFilterType.MoreThanAgo],
		disabled: false,
		value: DateFilterType.MoreThanAgo
	};

	render() {
		const radioButtonChecked = (this.props.selectedRadioButtonId === this.radioButton.value);
		return (
			<div className={"c-filter-dates_inputs_row"}>
				<RadioButton radioButton={this.radioButton}
							 onChange={() => this.props.onSelectButton(this.radioButton.value)}
							 checked={this.props.selectedRadioButtonId === this.radioButton.value}/>
				<input className={"c-filter-dates_input_more-than"}
					   type="number"
					   value={this.state.inputEndValue}
					   onChange={this.onChangeInput}
					   disabled={!radioButtonChecked}/>
				<OptionSelector selectableOptions={unitsOfTime}
								onSelect={this.onChangeSelector}
								disabled={!radioButtonChecked}
								selectedOption={this.state.selectedUnitOfTime}/>
				<label className={"t-body c-filter-dates_inputs_row_label"}>ago</label>
			</div>
		);
	}

	/**
	 * On change in "More than ago" input
	 */
	onChangeInput(e: React.FormEvent<HTMLInputElement>) {
		if (e.currentTarget.value.length == 0 || NumberUtils.isNumber(e.currentTarget.value)) {
			this.setState({inputEndValue: e.currentTarget.value}, this.onChangeCallback);
		}
	}

	/**
	 * On change in "More than ago" selector
	 */
	onChangeSelector(selectedUnitOfTime: DurationConstructor) {
		this.setState({selectedUnitOfTime: selectedUnitOfTime}, () => {
			this.onChangeCallback();
		})
	}

	/**
	 * On any change callback
	 */
	onChangeCallback() {
		const timeValue = this.state.inputEndValue;
		const unitOfTime = this.state.selectedUnitOfTime;
		if (timeValue && unitOfTime) {
			this.props.onChange(option(new MoreThanAgoFilterModel(Number(timeValue), unitOfTime)));
		}
		else {
			this.props.onChange(none);
		}
	}

	/**
	 * Reset filter
	 */
	resetFilter() {
		this.setState({inputEndValue: ""});
	}
}

export class MoreThanAgoFilterModel extends DateFilterModel {
	constructor(public readonly timeValue: number,
		public readonly unitOfTime: DurationConstructor) {
		super(DateFilterType.MoreThanAgo)
	}

	getDisplayValue(): string {
		return `${super.getDisplayValue()} ${this.timeValue} ${this.unitOfTime} ago`;
	}

	toQueryJson(): DateFilterValueItemApiDto[] {
		return [{value: this.timeValue * -1, rangeUnit: this.unitOfTime.toUpperCase()}]
	}

	static fromJson(json: DateFilterValueItemApiDto[]) {
		return new MoreThanAgoFilterModel(json[0].value * -1, json[0].rangeUnit.toLowerCase() as DurationConstructor)
	}
}
